import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialog,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from "@angular/material";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "src/app/app.config";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
import { MonthClosureService } from "src/app/shared/service/month-closure.service";
import { UserService } from "src/app/shared/service/user.service";
import { isNullOrUndefined } from "util";

@Component({
  selector: "app-hr-lop-details",
  templateUrl: "./hr-lop-details.component.html",
  styleUrls: ["./hr-lop-details.component.css"],
})
export class HRLoPDetailsComponent implements OnInit {
  lopDataSource: MatTableDataSource<any>;
  lopdisplayedColumns: string[] = [
    "NamePerRecords",
    "LocationName",
    "Department",
    "CadreName",
    "LoPDays",
    "remove",
  ];
  error: string;
  employeeList = [];
  employeeDetails = [];
  currentMonth = "";
  currentFY = "";
  isFreeze = true;
  lopFrom: any;
  isVisible: boolean = false;
  @ViewChild("loppaginatorAll", { static: true }) loppaginatorAll: MatPaginator;
  @ViewChild("lopsortAll", { static: true }) lopsortAll: MatSort;
  constructor(
    private _service: MonthClosureService,
    private config: AppConfig,
    public router: Router,
    private toastr: ToastrService,
    private _userService: UserService,
    private lopFormBuilder: FormBuilder,
    private dialog: MatDialog
  ) {
    this.lopFrom = this.lopFormBuilder.group({
      lopDetails: this.lopFormBuilder.array([], this.duplicateRowValidator),
    });
    this.lopDataSource = new MatTableDataSource();
  }
  ngOnInit() {
    // this.getLoPDetails();
  }
  lopemployeeSelectd(event, row) {
    row.EmpCode = event.option.id;
    var emp = this.employeeDetails.filter(
      (c) => c.EmpCode == event.option.id
    )[0];
    row.LocationName = emp.LocationName;
    row.Department = emp.Department;
    row.CadreName = emp.CadreName;
    row.FY = this.currentFY;
    row.Month = this.currentMonth;

    row.NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
  }

  create() {
    var row = {
      NamePerRecords: "",
      LocationName: "",
      Department: "",
      CadreName: "",
      LoPDays: "",
      remove: "",
    };
    return row;
  }
  doLOpOnEmployee(element) {
    //this.employeeList = [...this.employeeDetails];
    if (!isNullOrUndefined(element.NamePerRecords)) {
      this.employeeList = this.filterEmployee(
        this.employeeDetails,
        element.NamePerRecords
      );
      // element.id = 0;
    }
  }

  filterEmployee(values, NamePerRecords) {
    return values.filter((value) =>
      value.NamePerRecords && value.NamePerRecords !== ""
        ? value.NamePerRecords.toLowerCase().includes(
            NamePerRecords.toLowerCase()
          ) || value.EmpCode.toString().includes(NamePerRecords)
        : false
    );
  }

  duplicateRowValidator = (formArray: any): { [key: string]: any } | null => {
    const rows = (formArray as FormArray).controls;

    // Only map values from enabled controls
    let values = rows
      .filter((row) => row.get("NamePerRecords") && !row.get("NamePerRecords").disabled) // Filter out disabled rows
      .map((row) => row.get("NamePerRecords").value);

    if (!!values && values.length > 0) {
      // Find duplicates by comparing index positions
      const duplicates = values.filter((value, index) => values.indexOf(value) !== index);

      rows.forEach((row) => {
        const valueControl = row.get("NamePerRecords");

        if (valueControl && !valueControl.disabled) {  // Only check enabled controls
          if (valueControl.value !== "") {
            valueControl.setErrors(
              duplicates.includes(valueControl.value) ? { duplicate: true } : null
            );
          }
        }
      });

      return duplicates.length > 0 ? { duplicate: true } : null;
    }

    return null;
  };

  removeAt($event: any, index: number, row: any) {
    const message = "Are you sure you want to delete this record?";
    const dialogData = new ConfirmDialogModel(
      "Confirm Delete",
      message,
      "Submit",
      "OK",
      "Cancel"
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        $event.preventDefault();
        let data = this.lopDataSource.data;
        if (!!row && row.LoPId > 0) {
          row.IsActive = true;
          var result = this.lopDataSource.data.filter(
            (s) => s.IsActive == true
          );
          if (result != null && result.length > 0) {
            result[0].LoginUserName = this._userService.getEmail();
            result[0].IsFreezed = this.isFreeze;
            this._service.saveLoPDetails(result).subscribe(
              (result: any[]) => {
                this.toastr.success("Deleted Successfully");
                const items = this.lopFrom.get("lopDetails") as FormArray;
                // Remove the control at the specified index
                items.removeAt(index);
                this.lopDataSource.data = this.lopDataSource.data.filter(
                  (c) => c.IsActive != true
                );
              },
              (error) => (this.error = error)
            );
          }
        } else {
          data.splice(index, 1);
          const items = this.lopFrom.get("lopDetails") as FormArray;
          // Remove the control at the specified index
          items.removeAt(index);
          this.lopDataSource.data = data.filter((c) => c.IsActive != true);
          //this.getLoPDetails();
        }

        // this.lopDataSource.data = data.filter(c=>c.IsActive!=true);
        // let validationArray = this.lopFormBuilder.array([],this.duplicateRowValidator);
        // this.lopDataSource.data.forEach((detail) => {
        //   if (detail.IsActive != true)
        //     validationArray.push(this.createLoPFormGroup(detail));
        // });
        // this.lopFrom.setControl("lopDetails", validationArray);
      }
    });
  }
  addRow() {
    this.lopDataSource.data.push(this.create());
    this.lopDataSource.filter = "";
    let validationArray = this.lopFormBuilder.array(
      [],
      this.duplicateRowValidator
    );

    this.lopDataSource.data.forEach((detail) => {
      validationArray.push(this.createLoPFormGroup(detail));
    });
    this.lopFrom.setControl("lopDetails", validationArray);
  }
  getLoPDetails() {
    this.lopDataSource.data = [];
    this._service.getLoPDetails(this.currentMonth).subscribe(
      (data: any[]) => {
        let validationArray = this.lopFormBuilder.array(
          [],
          this.duplicateRowValidator
        );
        if (data != null && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            var emp = this.employeeDetails.filter(
              (c) => c.EmpCode == data[i].EmpCode
            )[0];
            data[i].LocationName = data[i].Location;
            data[i].Department = data[i].Department;
            data[i].CadreName = data[i].Cadre;
            if (!!emp)
              data[i].NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
            
            validationArray.push(this.createLoPFormGroup(data[i]));
          }
        }
        this.lopFrom.setControl("lopDetails", validationArray);
        if (data != null && data.length > 0) {
          if (this.isFreeze == false) {
            this.isFreeze = data[0].IsFreezed;
          }
          this.lopDataSource.data = data;
          this.lopDataSource.paginator = this.loppaginatorAll;
          this.lopDataSource.sort = this.lopsortAll;
        }
      },
      (error) => (this.error = error)
    );
  }
  changed(row) {
    row.IsUpdated = true;
  }
  saveLopDetails() {
    if (this.lopFrom.invalid) {
      this.toastr.warning("Please fill in the required fields");
      this.lopFrom.markAllAsTouched();
      return;
    }
    var result = this.lopDataSource.data.filter(
      (s) => s.isFromSabbatical != true &&
       ( s.IsActive == false || s.IsActive == null || s.IsActive == undefined)
    );
    if (result != null && result.length > 0) {
      result[0].LoginUserName = this._userService.getEmail();
      result[0].IsFreezed = this.isFreeze;
      this._service.saveLoPDetails(result).subscribe(
        (data: any[]) => {
          this.toastr.success("Saved Successfully");
          this.getLoPDetails();
        },
        (error) => (this.error = error)
      );
    }
  }
  get lopValidation(): FormArray {
    if (!!this.lopFrom && !!this.lopFrom.controls)
      return this.lopFrom.controls["lopDetails"] as FormArray;
  }
  private createLoPFormGroup(item: any): FormGroup {
    return new FormGroup({
     
      NamePerRecords: new FormControl(
        { value: item.NamePerRecords, disabled: this.isFreeze==false?item.isFromSabbatical:this.isFreeze },
        [Validators.required]
      ),

      LoPDays: new FormControl(
        { value: item.LoPDays, disabled: this.isFreeze==false?item.isFromSabbatical:this.isFreeze},
        [
          Validators.required,
          //Validators.pattern("^(?!0$)\\d{1,3}(\\.\\d{0,2})?$"),
          Validators.pattern(/^(?!0(\.0+$)?$)(0|[1-9]\d{0,2})(\.\d{1,2})?$/),
         
        ]
      ),
    });
  }
}
